import { svgIcon } from "../icon-service";

export const EmailIcon = svgIcon`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="67"
    height="64"
    fill="none"
    class="tw-text-primary-600"
    role="img"
    aria-label="[title]"
  >
    <title>Email</title>
    <path
      stroke="currentColor"
      stroke-width="2"
      d="m9.28 19.155-5.848 4.363a4 4 0 0 0-1.608 3.206V59a4 4 0 0 0 4 4h56.044a4 4 0 0 0 4-4V26.742a4 4 0 0 0-1.63-3.223L58.3 19.155M42.438 7.49l-6.442-4.736a4 4 0 0 0-4.762.017l-6.324 4.72"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="2"
      d="M58.373 30.978V9.473a2 2 0 0 0-2-2H11.318a2 2 0 0 0-2 2v21.505"
    />
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M64.504 61.637 43.35 42.107a6 6 0 0 0-4.07-1.59H27.421a6 6 0 0 0-4.175 1.69l-20.06 19.43"
    />
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="2"
      d="m65.181 27.239-22.81 13.623M2.51 27.24l22.81 13.622"
    />
    <rect width="35" height="12" x="16.324" y="17.5" stroke="currentColor" rx="6" />
    <circle cx="21.324" cy="23.5" r="1.5" fill="currentColor" />
    <circle cx="31.324" cy="23.5" r="1.5" fill="currentColor" />
    <circle cx="41.324" cy="23.5" r="1.5" fill="currentColor" />
    <circle cx="36.324" cy="23.5" r="1.5" fill="currentColor" />
    <circle cx="46.324" cy="23.5" r="1.5" fill="currentColor" />
  </svg>
`;
